<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <filter-by-status-header
            ref="headerFilter"
            :filterStatus="filterStatus"
            :filterOptions="filterOptions"
            :title="'Văn bản đi đã phát hành'"
            @filterByStatus="filterByStatus"
          />
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class=" margin-left-10">
                  <!--                hoang xuất kêt quả tìm kiếm -->
                  <el-tooltip class="item" effect="dark" content="Kết xuất kết quả tìm kiếm" placement="top-end">
                    <el-button
                      size="medium"
                      @click="chosenFileType"
                      type="primary">
                      <div class="flex-row flex__center">
                        <i class="fas fa-file-export"></i>
                        <span>&nbsp;KẾT XUẤT</span>
                      </div>
                    </el-button>
                  </el-tooltip>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div class="flex-row margin-right-40">
                      <span class="style-fullWidth label-input margin-right-10 no_wrap">Quan trọng: </span>
                      <input
                        style="display: none"
                        type="checkbox"
                        ref="starCheckbox"
                        v-model="isStar"
                      >
                      <div class="theTitle__star" @click="isStarChange">
                        <i :class="{'fas fa-star' : isStar, 'fal fa-star' : !isStar}" />
                      </div>
                    </div>
<!--                    <div-->
<!--                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"-->
<!--                    >-->
<!--                      <span class="label-input width__auto"-->
<!--                      >Ngày văn bản:-->
<!--                      </span>-->
<!--                      <el-date-picker-->
<!--                        v-model="docDateRange"-->
<!--                        type="daterange"-->
<!--                        format="dd/MM/yyyy"-->
<!--                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"-->
<!--                        :picker-options="dateQuickFilterOption"-->
<!--                        range-separator="_"-->
<!--                        start-placeholder="_"-->
<!--                        end-placeholder="_"-->
<!--                        align="center"-->
<!--                        :clearable="false"-->
<!--                        @change="filterByDocDateRange"-->
<!--                      >-->
<!--                      </el-date-picker>-->
<!--                    </div>-->
                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto"
                      >Ngày văn bản:
                      </span>
                      <span class="label-input width__auto">Từ ngày:</span>
                      <el-date-picker
                        v-model="fromDocDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày bắt đầu"
                        align="right"
                        :clearable="false"
                        @change="filterByDocDateRange"
                      ></el-date-picker>
                    </div>

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto">Đến ngày:</span>
                      <el-date-picker
                        v-model="toDocDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày kết thúc"
                        align="right"
                        :clearable="false"
                        @change="filterByDocDateRange"
                      ></el-date-picker>
                    </div>

                    <div class="margin-right-10 txt-center fix-width__small">
                      <multiselect
                        :class="['style-fullWidth']"
                        :options="docReadStatusFilters"
                        label="name"
                        track-by="id"
                        v-model="docReadStatusFilter"
                        :preselect-first="true"
                        placeholder="-"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :searchable="true"
                        open-direction="bottom"
                        @input="filterByDocReadStatus"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <div
                            class="status-doc flex-row flex__left font-size__medium"
                          >
                            &nbsp;&nbsp;
                            <filterIconByIsRead :isRead="option.id"/>
                            <span>{{ option.name }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </template>
                  <template #advance>
                    <banhanh-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      :isEnableSearchTdhvpDoc="true"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                      @searchTdhvpDoc="searchTdhvpDoc"
                      @searchLockedRoleDocOut="searchLockedRoleDocOut"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5 theTitle--hasStar">
                    STT
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left margin-left-10"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left"
                    @click="doSort('signerName')"
                  >
                    Người ký duyệt
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'signerName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in outgoingDocs"
                    v-bind:key="$itemIndex"
                    :class="[
                      'item flex-row flex__between clickable',
                      !item.isSeen ? 'is-seen' : ''
                    ]"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle--hasStar">
                        <div class="flex-row flex__between">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                                $itemIndex + 1
                              }}</span>
                          </div>
                          <i
                            class="fas fa-file color__smoke"
                            @click.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DI
                              )
                            "
                          ></i>
                          <div class="theTitle__star">
                            <i
                              :class="{'fal fa-star': !item.isStar, 'fas fa-star': item.isStar}"
                              @click.stop="changeStar(item)"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10 margin-left-10">
                        <div class="title-docs flex-col flex__left">
                          <div
                            class="tt_1 clickable"
                            v-bind:class="textBold(item)"
                          >
                            {{ item.quote }}
                          </div>
                          <div class="tt_2 flex-row flex__left margin-top-10">
                            <span v-if="item.docCode"
                            >{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag>

                            <el-tag
                              v-if="isShowPiority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <i class="fas fa-bolt"></i>
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                            <span>
                               <el-tooltip
                                 content="Văn bản điện tử"
                                 placement="top"
                                 effect="dark"
                                 v-if="isVbDienTu(item)"
                               >
                                 <div class="eIcon">e</div>
                               </el-tooltip>
                            </span>
                            <span>
                               <el-tooltip
                                 content="Đã ban hành bản giấy"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isBanHanhBanGiay"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                            <span>
                               <el-tooltip
                                 content="Không có tài liệu đính kèm"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isNotFileDinhKem"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-signing"></i>
                          {{ item.signerName }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                            item.docDate
                              | dateFormatter({
                              nullValue: "-",
                              dateFormat: "DD/MM/YYYY"
                            })
                          }}
                        </div>
                      </div>

                      <div class="theQuickAction flex-row flex__right">
                        <el-tooltip content="In phiếu xử lý" placement="top">
                          <i
                            @click.stop="inPhieuTrinhKi(item)"
                            class="action-icon bgAmbient__green clickable fas fa-print"
                          ></i>
                        </el-tooltip>
                        <el-tooltip
                          @click.native.stop="CCvanBan(item)"
                          content="CC"
                          placement="top"
                        >
                          <!-- <img
                            src="../../assets/img/CC.svg"
                            alt
                            class="action-icon clickable border-radius__50"
                          > -->
                          <i
                            class="action-icon bgAmbient__blue clickable fas fa-closed-captioning"
                          ></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
      <chosen-file-type-dialog
        v-if="isOpenChosenFileTypeDialog"
        @closeDialog="isOpenChosenFileTypeDialog= false"
        @exportResult="exportResult"
        :is-open="true">
      </chosen-file-type-dialog>
      <createDialog
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        @closed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
      />

      <CCDocOut
        :isOpen="isOpenDocOutCCDialog"
        :docId="selectedDoc.vbOutgoingDocUserViewKey.id"
        :docTitle="selectedDoc.quote"
        @closeDialog="isOpenDocOutCCDialog = false"
        @closed="isEnableDocOutCCDialog = false"
        v-if="isEnableDocOutCCDialog"
        @success="ccSuccess"
      />
    </template>
  </listTemplate>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import dateFormatter from "../../filters/dateFormatter";
import utils from "../../services/utils";
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import listTemplate from "../common/list";
import headerTemplate from "../../components/header/main-header.vue";
import searchTemplate from "../common/search";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vbOutgoingDocUserViewService from "../../services/vbOutgoingDocUserViewService";
import constants from "../../constants";
import {EventBus} from "../../event-bus.js";
import dateUtils from "../../dateUtils";
import CCDocOut from "./components/CCDocOut";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import buildAttachmentURL from "../../filters/buildAttachmentURL";
import FilterByStatusHeader from "./components/filter-by-status-header";
import BanhanhAdvanceSearchDialog from "./components/banhanh-advance-search-dialog";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import h from "../../services/h";
import chosenFileTypeDialog from "./chosenFileTypeDialog";
import vbDocUserService from "../../services/vbDocUserService";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  components: {
    chosenFileTypeDialog,
    BreakWordSpan,
    BanhanhAdvanceSearchDialog,
    FilterByStatusHeader,
    InfiniteLoading,
    listTemplate,
    headerTemplate,
    searchTemplate,
    VuePerfectScrollbar,
    subHeader: () => import("../../components/main/sub-header.vue"),
    createDialog: () => import("./components/CreateDialog.vue"),
    advanceSearchDialog: () =>
      import("./components/daBanHanhAdvanceSearchDialog.vue"),
    mainContent: () => import("./mainContent.vue"),
    Multiselect: () => import("vue-multiselect"),
    SortCaret: () => import("./SortCaret"),
    CCDocOut,
    filterIconByIsRead: () => import("../common/filterIconIsReadVban.vue")
  },

  mixins: [vbAttachmentTokenMixin],

  filters: {dateFormatter, buildAttachmentURL},

  data() {
    return {
      isOpenChosenFileTypeDialog: false,
      sortList: [],
      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      ROLE: constants.ROLE,
      selectedDoc: null,
      isOpenDocOutCCDialog: false,
      isEnableDocOutCCDialog: false,

      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
      filterOptions: null,

      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      perfectScrollbarSetting: {maxScrollbarLength: 350},
      outgoingDocs: [],
      page: 0,
      size: 10,
      advanceSearchForm: {},
      sort: null,
      order: null,
      keyword: null,
      docDateRange: [null, null],
      fromDocDate: null,
      toDocDate: null,
      filterStatus: null,
      docReadStatusFilter: null,
      userDeptRole: null,
      docReadStatusFilters: [
        {
          id: null,
          name: "Tất cả"
        },
        {
          id: constants.READ_STATUS.UN_READ,
          name: "Chưa đọc"
        },
        {
          id: constants.READ_STATUS.READED,
          name: "Đã đọc"
        }
      ],
      isStar: false
    };
  },

  computed: {
    currentRoute() {
      return this.$route.path.split("/")[3];
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    ...mapState("outgoingDocs", ["eventData"]),
    ...mapGetters("outgoingDocs", ["requiresListReload"]),
  },

  mounted() {
    EventBus.$on(this.currentRoute, options => {
      this.doSearch();
    });
  },

  watch: {
    isOpenDialogCreate: function (newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },
    isOpenAdvanceSearchDialog: function (newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },
    isOpenDocOutCCDialog(newValue) {
      newValue && (this.isEnableDocOutCCDialog = newValue);
    },
    eventData(newEvent) {
      if (this.requiresListReload) {
        console.log(`Reloading list due to event ${newEvent.action}`);
        this.doSearch()
        this.clearEvent(); // Reset the event after handling
      }
    }
  },

  created() {
    this.initQuery();
    this.loadUserDeptRole().then(() => this.initFilterOptions());
    this.setDefaultDocDateRange();
    this.filterByDocDateRange();
  },

  methods: {
    ...mapActions("outgoingDocs", ["clearEvent"]),

    searchTdhvpDoc() {
      this.$router.push({
        name: "tdhvpDocOutIndex",
        params: this.$route.params
      });
    },

    searchLockedRoleDocOut() {
      this.$router.push({
        name: "lockedRoleDocOutIndex",
        params: this.params
      });
    },

    isVbDienTu(item){
      if(item.eFlag&&item.eFlag==='1'){
        return true;
      }else {
        return false;
      }
    },
    inPhieuTrinhKi(item) {
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.VB_DI;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize({docId: item.docId})}`,
      );
    },
    chosenFileType() {
      this.isOpenChosenFileTypeDialog = true
    },
    exportResult(item) {
      this.isOpenChosenFileTypeDialog = false
      this.exportSearchResult(item, 'VAN_BAN_DA_PHAT_HANH')
    },
    filterByDocReadStatus(event) {
      this.advanceSearchForm.isRead = event.id === null ? undefined : event.id;
      this.doSearch();
    },

    CCvanBan(item) {
      this.selectedDoc = item;
      //console.log(this.selectedDoc)
      this.isOpenDocOutCCDialog = true;
    },

    ccSuccess() {
      this.isOpenDocOutCCDialog = false;
    },

    // filterByDocDateRange() {
    //   this.advanceSearchForm.fromDocDate =
    //     this.docDateRange && this.docDateRange[0]
    //       ? this.docDateRange[0].getTime()
    //       : undefined;
    //   this.advanceSearchForm.toDocDate =
    //     this.docDateRange && this.docDateRange[1]
    //       ? this.docDateRange[1].getTime()
    //       : undefined;
    //   this.doSearch();
    // },

    setDefaultDocDateRange() {
      // Lấy ngày đầu tiên của năm hiện tại
      const startDate = new Date(new Date().getFullYear(), 0, 1);

      // Đặt giá trị mặc định cho fromDocDate
      this.fromDocDate = startDate;

    },

    filterByDocDateRange() {
      // Kiểm tra xem cả hai fromDocDate và toDocDate đều null hoặc không đúng định dạng
      const fromDateValid = this.isValidDate(this.fromDocDate);
      const toDateValid = this.isValidDate(this.toDocDate);

      if ((this.fromDocDate === null || !fromDateValid) && (this.toDocDate === null || toDateValid)) {
        // Nếu fromDocDate không hợp lệ hoặc null và toDocDate hợp lệ, chỉ reset lại fromDocDate
        this.fromDocDate = new Date(new Date().getFullYear(), 0, 1);
      } else if ((this.toDocDate === null || !toDateValid) && (this.fromDocDate === null || fromDateValid)) {
        // Nếu toDocDate không hợp lệ hoặc null và fromDocDate hợp lệ, chỉ reset lại toDocDate
        this.toDocDate = new Date(new Date().getFullYear(), 11, 31);
      } else if (this.fromDocDate > this.toDocDate) {
        // Nếu fromDocDate lớn hơn toDocDate, đảm bảo rằng fromDocDate nhỏ hơn hoặc bằng toDocDate
        this.fromDocDate = new Date(new Date().getFullYear(), 0, 1);
        this.toDocDate = new Date(new Date().getFullYear(), 11, 31);
      }

      this.advanceSearchForm.fromDocDate = this.fromDocDate ? this.fromDocDate.getTime() : undefined;
      this.advanceSearchForm.toDocDate = this.toDocDate ? this.toDocDate.getTime() : undefined;
      this.doSearch();
    },

    isValidDate(date) {
      return date instanceof Date && !isNaN(date);
    },

    initQuery() {
      this.sort = this.$route.query.sort || "docDate";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        keyword: this.$route.query.keyword || undefined,
        filterStatus:
          this.$route.query.filterStatus || constants.DU_THAO_PAGE.FILTER.ALL,

        fromDocDate: this.$route.query.fromDocDate
          ? parseInt(this.$route.query.fromDocDate)
          : undefined,
        toDocDate: this.$route.query.toDocDate
          ? parseInt(this.$route.query.toDocDate)
          : undefined,

        fileContent: this.$route.query.fileContent || undefined,
        docTypeId: this.$route.query.docTypeId || undefined,
        priorityId: this.$route.query.priorityId || undefined,
        quote: this.$route.query.quote || undefined,
        otherReceivePlaces: this.$route.query.otherReceivePlaces || undefined,
        receiveDeptId: this.$route.query.receiveDeptId || undefined,
        publisherId: this.$route.query.publisherId || undefined,
        isRead: this.$route.query.isRead
          ? parseInt(this.$route.query.isRead)
          : undefined,
        isStar: this.$route.query.isStar === "1" ? 1 : 0
      };

      this.docReadStatusFilter = h.find(
        this.docReadStatusFilters,
        item =>
          item.id ===
          (this.advanceSearchForm.isRead === undefined
            ? null
            : this.advanceSearchForm.isRead)
      );
      this.filterStatus = this.advanceSearchForm.filterStatus;
      this.keyword = this.advanceSearchForm.keyword;
      this.isStar = !!+this.$route.query.isStar;
      this.initDocDateRange();
    },

    buildQuery() {
      return utils.merge(
        {sort: this.sort || "updateTime", order: this.order || "desc"},
        this.advanceSearchForm
      );
    },

    filterByStatus(event) {
      this.advanceSearchForm.filterStatus = this.filterStatus =
        event.filterStatus;
      this.doSearch();
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.advanceSearchForm.priorityId = undefined;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.publisherId = undefined;
      this.advanceSearchForm.receiveDeptId = undefined;
      this.advanceSearchForm.otherReceivePlaces = undefined;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.sortList = event.sortList;
      this.advanceSearchForm.keyword = undefined;
      this.keyword = null;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.fileContent =
        advanceSearchForm.fileContent || undefined;
      this.advanceSearchForm.priorityId =
        advanceSearchForm.priorityId || undefined;
      this.advanceSearchForm.docTypeId =
        advanceSearchForm.docTypeId || undefined;
      this.advanceSearchForm.publisherId =
        advanceSearchForm.publisherId || undefined;
      this.advanceSearchForm.receiveDeptId =
        advanceSearchForm.receiveDeptId || undefined;
      this.advanceSearchForm.otherReceivePlaces =
        advanceSearchForm.otherReceivePlaces || undefined;
      this.advanceSearchForm.fromDocDate =
        advanceSearchForm.fromDocDate || undefined;
      this.advanceSearchForm.toDocDate =
        advanceSearchForm.toDocDate || undefined;
      this.advanceSearchForm.sortList =
        event.sortList || undefined;
      this.initDocDateRange();
      this.doSearch();
    },

    initDocDateRange() {
      if (
        this.advanceSearchForm.fromDocDate ||
        this.advanceSearchForm.toDocDate
      ) {
        this.docDateRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
          dateUtils.toMoment(this.advanceSearchForm.toDocDate)
        ];
      } else {
        this.docDateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        );
        this.advanceSearchForm.fromDocDate = defaultTimeRange[0];
        this.advanceSearchForm.toDocDate = defaultTimeRange[1];
      }
    },

    doSort(sort) {
      this.sort = sort;
      this.order =
        sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: "vbDaPhatHanhNew",
        params: this.$route.params,
        query: this.buildQuery()
      });
      this.outgoingDocs = [];
      this.page = 0;
      this.$nextTick(() => this.$refs.infiniteLoading.stateChanger.reset());
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    async list() {
      let pageable;
      if (this.sortList && this.sortList.length > 0) {

        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: this.page,
          size: this.size,
          sort: sort
        };
      } else {
        pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };
      }
      let docStatus = [constants.OUTGOING_DOC_STATUS.DABANHANH];

      let relationType;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
          break;
        case constants.DU_THAO_PAGE.FILTER.CC:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_CC;
          break;
        case constants.DU_THAO_PAGE.FILTER.KY_DUYET:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_KY_DUYET;
          break;
        default:
          relationType = null;
          break;
      }

      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        docStatus: docStatus,
        relationType: relationType,
        status: status
      });

      let items = [];

      await vbOutgoingDocUserViewService
        .findAll2(advanceSearchForm, pageable)
        .then(response => {
          items = response.data;
        });
      await vbDocUserService.getAllVbIsStarByUserDeptRole(this.userDeptRoleId)
        .then(response => {
          const vbDocIdsIsStarMap = response.data;

          for(let i = 0; i < items.length; i++) {
            items[i].isStar = 0;
            for(let key in vbDocIdsIsStarMap) {
              if (key === items[i].docId) {
                items[i].isStar = vbDocIdsIsStarMap[key]
              }
            }
          }
          this.outgoingDocs.push(...items);
        })
      return items;
    },
    exportSearchResult(fileType,name) {
      let pageable;
      if (this.sortList && this.sortList.length > 0) {

        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: 0,
          size: 1000,
          sort: sort
        };
      } else {
        pageable = {
          page: 0,
          size: 1000,
          sort: [this.sort, this.order].join(",")
        };
      }
      let docStatus = [constants.OUTGOING_DOC_STATUS.DABANHANH];

      let relationType;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
          break;
        case constants.DU_THAO_PAGE.FILTER.CC:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_CC;
          break;
        default:
          relationType = null;
          break;
      }

      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        docStatus: docStatus,
        relationType: relationType,
        status: status
      });
      let params = utils.merge(advanceSearchForm, pageable)
      params.userId = this.$store.getters.userDeptRole.userId;
      params.deptId = this.$store.getters.userDeptRole.deptId;
      params.roleId = this.$store.getters.userDeptRole.roleId;
      params.positionId = this.$store.getters.userDeptRole.positionId;
      params.fileType = fileType
      params.name = name

      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.SEARCH_RESULT_VB_DU_THAO;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(params)}`
      );
      // return vbOutgoingDocUserViewService
      //   .findAll2(advanceSearchForm, pageable)
      //   .then(response => {
      //     let items = response.data;
      //     items && this.outgoingDocs.push(...items);
      //     return items;
      //   });
    },

    viewDetail(item) {
      item.isSeen = 1;
      let query = utils.merge(this.$route.query, {
        vbDocProcessId: item.vbDocUserVbDocProcessId
      });
      this.$router.push({
        name: "vbDaPhatHanhNewDetail",
        params: {
          userDeptRoleId: this.userDeptRoleId,
          id: item.vbOutgoingDocUserViewKey.id
        },
        query: query
      });
    },

    initFilterOptions() {
      this.filterOptions = [];

      this.filterOptions.push({
        value: constants.DU_THAO_PAGE.FILTER.ALL,
        label: "Tất cả",
        iconClass: null
      });

      if (this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO) {
        this.filterOptions.push({
          value: constants.DU_THAO_PAGE.FILTER.KY_DUYET,
          label: "Ký duyệt",
          iconClass: null
        });

        this.filterOptions.push({
          value: constants.DU_THAO_PAGE.FILTER.UY_QUYEN,
          label: "Ủy quyền",
          iconClass: null
        });
      }

      this.filterOptions.push({
        value: constants.DU_THAO_PAGE.FILTER.CC,
        label: "CC",
        iconClass: null
      });

    },

    /**
     * neu la quyen lanh dao thi moi them tab uy quyen;
     */
    loadUserDeptRole() {
      return userDeptRoleViewService
        .findById(this.userDeptRoleId)
        .then(response => {
          this.userDeptRole = response.data;
        });
    },

    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPiority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    isSeen(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "is-seen";
      } else return "";
    },

    textBold(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "text-bold";
      } else return "";
    },

    isStarChange() {
      this.$refs.starCheckbox.click();
      const isStar = this.$refs.starCheckbox.checked ? 1 : 0;
      this.advanceSearchForm.isStar = isStar;
      this.doSearch();
    },

    changeStar(item) {
      const isStar = item.isStar === 1 ? 0 : 1

      vbDocUserService.setStar({
        vbDocId: item.id,
        userDeptRoleId: this.userDeptRoleId,
        isStar: isStar
      })
        .then(() => {
          item.isStar = isStar

          // Nếu đang filter theo văn bản có dấu sao thì sẽ reload trang nếu có thay đổi dấu sao của 1 văn bản
          if(this.isStar) {
            this.doSearch();
          }

        })
        .catch(() => {
          console.log('Không thể đánh dấu sao cho văn bản!')
        })
    }
  }
};
</script>

<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}

.text-bold {
  font-weight: bold;
}
.eIcon{
  border: solid 1px #007aff;
  border-radius: 2px;
  padding: 0px 3px;
  font-size: 11px;
  color: goldenrod;
  margin-left:2px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/VbDaPhatHanhNewIndex.vue